export default __webpack_public_path__ + "static/Electrical_Generator-491e22ec7bc3819bd5d7c38498be025e.png";